import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { Helmet } from 'react-helmet';
import { injectIntl, intlShape } from 'react-intl';
import { useFlow } from './FlowProvider';
import { replace } from './routing';
import { ROUTES } from './flowConstants';
import { runDependenciesAction } from './dependency/dependencyConfigModule';
import { routeChangedAction } from './routingModule';
import { getBrandName } from '../brand/brandSelectors';
import headerMessages from '../header/message/HeaderMessage';
import routingMessages from './messages/routingMessages';

export const Step = ({
    component: Component,
    stepName,
    hasDependencies,
    intl,
    brandName,
    pageTitle,
    ...props
}) => {
    const {
        findFirstIncompleteStep, stepHasChanged, showCurrencyPicker, showManageGiftcards, showCartInMobileHeader
    } = useFlow();
    const [shouldRender, setShouldRender] = useState(false);
    const pageTitleWithBrand = pageTitle ? `${intl.formatMessage(routingMessages[pageTitle])} | ${intl.formatMessage(headerMessages.pageTitle, { brandName })}` : null;

    const location = useLocation();

    useEffect(() => {
        stepHasChanged(stepName, location);
        showCurrencyPicker(stepName);
        showManageGiftcards(stepName);
        showCartInMobileHeader(stepName);
                if (window.RISKX) {
            window.RISKX.go(ROUTES[stepName]);
        }

        const firstIncompleteStep = findFirstIncompleteStep(stepName);
        if (firstIncompleteStep !== stepName) {
            replace({ pathname: ROUTES[firstIncompleteStep] });
        }

        
        props.routeChangedAction(stepName);

        if (hasDependencies) {
            
            props.runDependenciesAction(stepName);
        }

        
        
        if (pageTitleWithBrand) {
            document.title = pageTitleWithBrand;
        }

        
        setShouldRender(true);
    }, [stepName]);

    return shouldRender && (
        <>
            {pageTitleWithBrand && (
                <Helmet>
                    <title>
                        {pageTitleWithBrand}
                    </title>
                </Helmet>
            )}
            <Component stepName={stepName} />
        </>
    );
};

Step.displayName = 'Step';
Step.defaultProps = {
    hasDependencies: false,
    pageTitle: null
};
Step.propTypes = {
    component: PropTypes.func.isRequired,
    stepName: PropTypes.string.isRequired,
    runDependenciesAction: PropTypes.func.isRequired,
    hasDependencies: PropTypes.bool,
    routeChangedAction: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    brandName: PropTypes.string.isRequired,
    pageTitle: PropTypes.string
};
export const mapStateToProps = state => ({
    brandName: getBrandName(state)
});

export default connect(mapStateToProps, { runDependenciesAction, routeChangedAction })(injectIntl(Step));
